import { render, staticRenderFns } from "./Myfavoritethingsrule.vue?vue&type=template&id=14d6f0fe"
import script from "./Myfavoritethingsrule.vue?vue&type=script&lang=js"
export * from "./Myfavoritethingsrule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports